<template>
  <div>
    <div class="bg-white py-6">
      <!-- Replace with your content -->
      <div>
        <div class="md:flex md:items-center md:justify-between sm:px-6 md:px-8">
          <div class="flex-1 min-w-0">
            <h2 class="text-2xl font-bold leading-7 text-gray-800 sm:text-3xl sm:truncate">
              {{ $t("messages.player.id.playerProfile") }}
            </h2>
          </div>
          <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4">
            <!-- <button type="button" class="ml-3 inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500">
              Create New Player
            </button> -->
          </div>
        </div>
      </div>
    </div>
    <!-- /End replace -->

    <nav class="bg-white border-b border-t border-gray-200 flex" aria-label="Breadcrumb">
      <ol class="w-full mx-auto px-4 flex space-x-4 sm:px-6 md:px-8">
        <li class="flex">
          <div class="flex items-center">
            <a href="javascript:void(0)" class="text-gray-400 hover:text-gray-500">
              <HomeIcon class="flex-shrink-0 h-5 w-5" aria-hidden="true" />
              <span class="sr-only">Home</span>
            </a>
          </div>
        </li>
        <li v-for="page in pages" :key="page.name" class="flex">
          <div class="flex items-center">
            <svg class="flex-shrink-0 w-6 h-full text-gray-200" viewBox="0 0 24 44" preserveAspectRatio="none"
              fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
            </svg>
            <router-link :to="page.href" class="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
              :aria-current="page.current ? 'page' : undefined">{{ page.name }}</router-link>
          </div>
        </li>
      </ol>
    </nav>

    <div class="px-8 py-6" v-show="!isLoaded">
      <div class="space-y-8 divide-y divide-gray-200 bg-white px-10 py-9 rounded-md shadow-md text-center">
        <font-awesome-icon class="text-gray-500" :icon="['fas', 'circle-notch']" transform="grow-6" spin />
      </div>
    </div>

    <div class="py-6" v-show="isLoaded && userInfo.id">
      <div class="sm:px-6 md:px-8">
        <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6 rounded-md overflow-x-auto">
          <div class="-ml-4 -mt-4 flex justify-between items-start flex-wrap sm:flex-nowrap">
            <div class="ml-4 mt-4">
              <div class="flex items-center">
                <div class="ml-0">
                  <h3 class="text-lg leading-6 font-medium text-gray-900">
                    {{
                      userInfo && userInfo.accountNameTh
                        ? userInfo.accountNameTh
                        : "-"
                    }}
                  </h3>
                  <p class="text-sm text-gray-500 mt-1">
                    {{ $t("messages.player.id.username") }}
                    :
                    {{
                      userInfo && userInfo.username ? userInfo.username : "-"
                    }}
                  </p>
                  <p class="text-sm text-gray-500 mt-1">
                    {{ $t("messages.player.id.mobile") }}:
                    {{
                      userInfo && userInfo.phoneNumber
                        ? userInfo.phoneNumber
                        : "-"
                    }}
                  </p>
                  <p class="text-sm text-gray-500 mt-1">
                    {{ $t("messages.player.id.bank") }}:
                    {{
                      userInfo && userInfo.bankCode ? userInfo.bankCode : "-"
                    }}
                  </p>
                  <p class="text-sm text-gray-500 mt-1">
                    {{ $t("messages.player.id.accountNumber") }}:
                    {{
                      userInfo && userInfo.accountNumber
                        ? userInfo.accountNumber
                        : "-"
                    }}
                  </p>
                  <p class="text-sm text-gray-500 mt-1">
                    {{ $t("messages.player.id.applicationDate") }}:
                    {{
                      userInfo && userInfo.createdAt
                        ? dayjs(userInfo.createdAt).format("LLL")
                        : "-"
                    }}
                  </p>
                  <p class="text-sm text-gray-500 mt-1">
                    {{ $t("messages.player.id.currentLoyaltyPoints") }}:
                    {{
                      userInfo && userInfo.loyalty?.amount
                        ? userInfo.loyalty.amount
                        : "0"
                    }}
                    Points
                  </p>
                  <p class="text-sm text-gray-500 mt-1">
                    {{ $t("messages.player.id.currentRedemptionLimitPerDay") }}:
                    {{
                      userInfo && userInfo.redeemLimitPerDay
                        ? userInfo.redeemLimitPerDay
                        : "0"
                    }}
                    Times Per Day
                  </p>
                  <p class="text-sm text-gray-500 mt-6"></p>
                  <div class="flex items-center" v-if="
                    store.state.user.permissions.includes(
                      'USER.UPDATE_AFFILIATE_DASHBOARD'
                    )
                  ">
                    {{ $t("messages.player.id.affiliateDashboard") }}:
                    <!-- {{
                      userRoles
                        ? userRoles.toString()
                        : "-"
                    }} -->
                    <Switch style="height: 20px; width: 40px" :v-model="isAffiliateUser" @click="updateUserRole()"
                      :class="isAffiliateUser ? 'bg-blue-500' : 'bg-red-900'"
                      class="ml-3 relative inline-flex flex-shrink-0 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
                      <span style="width: 16px; height: 16px" :class="isAffiliateUser ? 'translate-x-5' : 'translate-x-0'
                        "
                        class="pointer-events-none inline-block rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200" />
                    </Switch>
                  </div>
                  <div class="flex flex-row items-center gap-2 mt-2" v-if="
                    store.state.user.permissions.includes(
                      'USER.UPDATE_STATUS'
                    )
                  ">
                    <p>
                      {{ $t("messages.player.id.suspend") }}/{{ $t("messages.player.id.activate") }}
                    </p>
                    <Switch style="height: 20px; width: 40px" :v-model="userInfo.isActive"
                      @click="updateSuspendData(userInfo)" :class="userInfo.isActive ? 'bg-blue-500' : 'bg-red-900'"
                      class="ml-3 relative inline-flex flex-shrink-0 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
                      <span style="width: 16px; height: 16px" :class="userInfo.isActive ? 'translate-x-5' : 'translate-x-0'
                        "
                        class="pointer-events-none inline-block rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200" />
                    </Switch>
                  </div>
                  <p v-if="!userInfo.isActive" class="text-red-900">{{ $t("messages.player.id.suspendedBy") }}: <b>{{
                    userActivityLogs[0]?.actorUsername || '-' }}</b> {{ $t("messages.player.id.dueTo") }}: <b>{{
                        userActivityLogs[0]?.notes || '-' }}</b></p>
                </div>
              </div>
            </div>
            <!-- <div class="mt-4 ml-4 lg:flex-shrink-0 flex">
              <div class="flex-col">
                <div>
                  <h3 class="text-lg leading-6 font-medium text-gray-900">
                    Loyalty
                  </h3>
                  <p class="text-sm text-gray-500 mt-1">
                    Current Points:
                    {{
                        userInfo && userInfo.loyalty?.point ? userInfo.loyalty.point : "-"
                    }}
                  </p>
                </div>
              </div>
            </div> -->
            <div class="lg:ml-4 mt-4 lg:flex-shrink-0 flex gap-4 max-w-2xl">
              <div class="flex-col flex-1">
                <button type="button" @click="toggleEditBankAccountV2Modal"
                  v-if="store.state.user.permissions.includes('PAYMENT_CONFIG.USER.UPDATE_BANK_ACCOUNT') && store.state.selectedOperator.paymentVersion !== 'v1'"
                  class="w-full ml-3 relative items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                  <font-awesome-icon class="mr-2" :icon="['far', 'money-check-edit']" />
                  <span v-if="store.state.user.permissions.includes('PAYMENT_CONFIG.USER.UPDATE_BANK_ACCOUNT')"> {{
                    $t("messages.player.id.editBankAccount") }}</span>
                </button>

                <button type="button" @click="toggleForceEditBankAccountV2Modal"
                  v-if="store.state.user.permissions.includes('PAYMENT_CONFIG.USER.FORCE_UPDATE_BANK_ACCOUNT') && store.state.selectedOperator.paymentVersion !== 'v1'"
                  class="w-full mt-3 ml-3 relative items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                  <font-awesome-icon class="mr-2" :icon="['far', 'money-check-edit']" />
                  <span v-if="store.state.user.permissions.includes('PAYMENT_CONFIG.USER.UPDATE_BANK_ACCOUNT')"> {{
                    $t("messages.player.id.forceEditBankAccount") }}</span>
                </button>
                <button type="button" @click="toggleForceEditBankAccountModal"
                  v-if="store.state.user.permissions.includes('PAYMENT_CONFIG.USER.FORCE_UPDATE_BANK_ACCOUNT') && store.state.selectedOperator.paymentVersion == 'v1'"
                  class="w-full mt-3 ml-3 relative items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                  <font-awesome-icon class="mr-2" :icon="['far', 'money-check-edit']" />
                  <span v-if="store.state.user.permissions.includes('PAYMENT_CONFIG.USER.UPDATE_BANK_ACCOUNT')"> {{
                    $t("messages.player.id.forceEditBankAccount") }}</span>
                </button>
<!--                <button type="button" @click="toggleEditBankAccountModal"-->
<!--                  v-if="store.state.user.permissions.includes('USER.UPDATE_BANK_ACCOUNT') && store.state.selectedOperator.paymentVersion !== 'v1'"-->
<!--                  class="w-full mt-3 ml-3 relative items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">-->
<!--                  <font-awesome-icon class="mr-2" :icon="['far', 'money-check-edit']" />-->
<!--                  <span v-if="store.state.user.permissions.includes('USER.UPDATE_BANK_ACCOUNT')"> {{-->
<!--                    $t("messages.player.id.editBankAcount") }}</span>-->
<!--                </button>-->
                <button v-if="
                  store.state.user.permissions.includes(
                    'USER.INFO_UPDATE'
                  ) ||
                  store.state.user.permissions.includes('USER.ADMIN_UPDATE')
                " type="button" @click="isUsernameUpdate = true"
                  class="w-full mt-3 ml-3 relative items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                  <font-awesome-icon class="mr-2" :icon="['far', 'signature']" />
                  <span> {{ $t("messages.player.id.updateUsername") }}</span>
                </button>
                <button type="button" @click="toggleChangePasswordModal"
                  v-if="store.state.user.permissions.includes('USER.UPDATE')"
                  class="w-full mt-3 ml-3 relative items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                  <font-awesome-icon class="mr-2" :icon="['far', 'key']" />
                  <span> {{ $t("messages.player.id.changePassword") }} </span>
                </button>
                <div class="mt-3" v-if="
                  store.state.user.permissions.includes(
                    'USER.UPDATE_REDEMPTION'
                  )
                ">
                  <button type="button" @click="isUpdateRedeemLimit = !isUpdateRedeemLimit" v-if="
                    store.state.user.permissions.includes('USER.UPDATE_BANK_ACCOUNT')
                  "
                    class="w-full ml-3 relative items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                    <font-awesome-icon class="mr-2" :icon="['far', 'sliders-h-square']" />
                    <span>
                      {{ $t("messages.player.id.updateRedemptionLimit") }}
                    </span>
                  </button>
                </div>
              </div>
              <div class="flex-col flex flex-1">
                <!--                  <div class="mt-3"></div>-->
<!--                <button-->
<!--                  v-if="store.state.selectedOperator?.paymentAccountTypes?.includes('MANUAL') &&-->
<!--                    store.state.user.permissions.includes('USER.MANUAL_WITHDRAW_CREATE') && store.state.selectedOperator.paymentVersion == 'v1'"-->
<!--                  type="button" @click="isShowManualPaymentWithdraw = true"-->
<!--                  class="w-full ml-3 relative items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">-->
<!--                  <font-awesome-icon class="mr-2" :icon="['far', 'money-bill']" />-->
<!--                  <span> {{ $t("messages.player.id.manualWithdraw") }} </span>-->
<!--                </button>-->
<!--                <button-->
<!--                  v-if="store.state.user.permissions.includes('RTB.DEPOSIT') && store.state.selectedOperator.paymentVersion == 'v1'"-->
<!--                  type="button" @click="isShowManualPaymentDeposit = true"-->
<!--                  class="w-full mt-3 ml-3 relative items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">-->
<!--                  <font-awesome-icon class="mr-2" :icon="['far', 'money-bill']" />-->
<!--                  <span> {{ $t("messages.player.id.manualDeposit") }} </span>-->
<!--                </button>-->
<!--                <button-->
<!--                  v-if="store.state.selectedOperator.paymentAccountTypes.includes('WOWSPAY') && store.state.selectedOperator.paymentVersion == 'v1'"-->
<!--                  type="button" @click="isShowQRDeposit = true"-->
<!--                  class="w-full mt-3 ml-3 relative items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">-->
<!--                  <font-awesome-icon class="mr-2" :icon="['far', 'money-bill']" />-->
<!--                  <span> {{ $t("messages.player.id.qrDeposit") }} </span>-->
<!--                </button>-->
                <button
                  v-if="store.state.user.permissions.includes('USER.MANUAL_WITHDRAW_CREATE') && store.state.selectedOperator.paymentVersion !== 'v1'"
                  @click="isShowManualPaymentWithdrawV2 = true" type="button"
                  class="w-full ml-3 relative items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                  <font-awesome-icon class="mr-2" :icon="['far', 'wallet']" />
                  <span> {{ $t("messages.player.id.manualWithdraw") }} </span>
                </button>
                <button
                  v-if="(store.state.user.permissions.includes('PAYMENT_CONFIG.DEPOSIT.MANUAL') || store.state.user.permissions.includes('RTB.DEPOSIT')) && store.state.selectedOperator.paymentVersion !== 'v1'"
                  @click="isShowManualPaymentDepositV2 = true" type="button"
                  class="w-full mt-3 ml-3  relative items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                  <font-awesome-icon class="mr-2" :icon="['far', 'piggy-bank']" />
                  <span> {{ $t("messages.player.id.manualDeposit") }} </span>
                </button>
                <button v-if="
                  store.state.user.permissions.includes('LOYALTY.TOPUP')
                " type="button" @click="isManualTopupPoint = true"
                  class="w-full mt-3 ml-3 relative items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
                  <font-awesome-icon class="mr-2" :icon="['far', 'medal']" />
                  <span>
                    {{ $t("messages.player.id.manualTopupPoint") }}
                  </span>
                </button>
                <button type="button"
                  class="w-full mt-3 ml-3 relative items-center px-4 py-2 border border-gray-300 shadow-sm text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                  @click="showCreateTicketModal = true">
                  <font-awesome-icon class="mr-2" :icon="['far', 'ticket-alt']" />
                  <span> {{ $t("messages.player.id.createTicket") }} </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="sm:px-6 md:px-8 pt-6">
        <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6 rounded-md">
          <div class="pb-5 border-b border-gray-200 sm:pb-0">
            <div class="mt-3 sm:mt-4">
              <div class="sm:hidden">
                <label for="current-tab" class="sr-only">
                  {{ $t("messages.player.id.selectTab") }}</label>
                <select id="current-tab" name="current-tab" v-model="selected_tab" @change="changePage()"
                  class="block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md">
                  <option v-for="tab in tabs" :key="tab.name" :selected="tab.route == route.name">
                    {{ $t(`messages.player.id.${camalize(tab.name)}`) }}
                  </option>
                </select>
              </div>
              <div class="hidden sm:block overflow-x-auto">
                <nav class="flex space-x-8">
                  <router-link v-for="tab in tabs" :key="tab.name" :to="tab.href" :class="[
                    tab.route == route.name
                      ? 'border-blue-500 text-blue-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300',
                    'whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm',
                  ]" :aria-current="tab.current ? 'page' : undefined">
                    {{ $t(`messages.player.id.${camalize(tab.name)}`) }}
                  </router-link>
                </nav>
              </div>
            </div>
          </div>
          <router-view />
        </div>
      </div>
      <!-- <div class="sm:px-6 md:px-8 pt-6" v-if="store.state.user.permissions.includes('ACTIVITY_LOG.READ')">
        <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6 rounded-md overflow-x-auto">
          <ActivityLogsPlayersProfile v-if="userInfo && userInfo.username" :affectedName="userInfo.username"
            :affectedId="userInfo.id" />
        </div>
      </div> -->
    </div>
    <div v-if="isLoaded && !userInfo?.id && !userInfo.isActive" class="px-4 grid grid-cols-1 place-items-center">
      <div class="bg-white px-4 py-5 border-b border-gray-200 sm:px-6 rounded-md mt-96">
        <p>{{ $t(`messages.player.id.thisUserSuspended`) }}</p>
        <div class="flex flex-row items-center gap-2">
          <p>
            {{ $t(`messages.player.id.suspend`) }}/{{
              $t(`messages.player.id.activate`)
            }}
          </p>

          <Switch style="height: 20px; width: 40px" :v-model="isSuspend" @click="onActiveUser($route.params.id)"
            :class="isSuspend ? 'bg-blue-500' : 'bg-red-900'"
            class="ml-3 relative inline-flex flex-shrink-0 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75">
            <span style="width: 16px; height: 16px" :class="isSuspend ? 'translate-x-5' : 'translate-x-0'"
              class="pointer-events-none inline-block rounded-full bg-white shadow-lg transform ring-0 transition ease-in-out duration-200" />
          </Switch>
        </div>
      </div>
    </div>
    <TransitionRoot as="template" :show="changePasswordOpen">
      <Dialog as="div" static class="fixed z-10 inset-0 overflow-y-auto" @close="changePasswordOpen = false"
        :open="changePasswordOpen">
        <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
            leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div
              class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6">
              <div>
                <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                  <font-awesome-icon class="text-green-600" :icon="['far', 'key']" transform="grow-2" />
                </div>
                <div class="mt-3 text-center sm:mt-5">
                  <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                    {{ $t(`messages.player.id.changePassword`) }}

                    <!-- <small class="text-gray-400">{{ userInfo.username }}</small> -->
                  </DialogTitle>
                  <div class="mt-8 pb-2 text-left">
                    <div class="mt-1">
                      <input type="text" v-model="newPassword" name="newPassword" id="newPassword"
                        class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        :placeholder="$t(`messages.player.id.newPassword`)" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                <button type="button" :disabled="isWorking" @click="savePassword"
                  class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm">
                  {{ $t(`messages.player.id.savePassword`) }}
                </button>
                <button type="button" @click="toggleChangePasswordModal"
                  class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                  ref="cancelButtonRef">
                  {{ $t(`messages.player.id.cancel`) }}
                </button>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
    <TransitionRoot as="template" :show="editBankAccountOpen">
      <Dialog as="div" static class="fixed z-10 inset-0 overflow-y-auto" @close="editBankAccountOpen = false"
        :open="editBankAccountOpen">
        <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
            leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div
              class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6">
              <div>
                <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                  <font-awesome-icon class="text-green-600" :icon="['far', 'money-check-edit']" transform="grow-2" />
                </div>
                <div class="mt-3 text-center sm:mt-5">
                  <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                    {{ $t(`messages.player.id.editBankAcount`) }}
                    <!-- <small class="text-gray-400">{{ userInfo.username }}</small> -->
                  </DialogTitle>
                  <div class="mt-8 pb-2 text-left">
                    <div>
                      <label for="location" class="block text-sm font-medium text-gray-700">
                        {{ $t(`messages.player.id.selectBank`) }}</label>
                      <select id="location" name="location" v-model="bankAccount.bank"
                        class="capitalize mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md">
                        <option v-for="bank in bankList" :key="bank.bankCode" :value="bank.bankCode">
                          {{ bank.description }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="mt-2 pb-2 text-left">
                    <div class="mt-1">
                      <label for="location" class="block text-sm font-medium text-gray-700">
                        {{ $t(`messages.player.id.accountNumber`) }}</label>
                      <input type="text" v-model="bankAccount.accountNumber" name="newPassword" id="newPassword"
                        class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        :placeholder="$t(`messages.player.id.accountNumber`)" />
                    </div>
                  </div>
                  <div class="mt-2 pb-2 text-left">
                    <label for="location" class="block text-sm font-medium text-gray-700">
                      {{ $t(`messages.player.id.accountName`) }}</label>
                    <input type="text" v-model="accountName" name="accountName" id="accountName"
                      class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                      :placeholder="$t(`messages.player.id.accountName`)" />
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
                v-if="store.state.user.permissions.includes('USER.UPDATE_BANK_ACCOUNT') && store.state.selectedOperator.paymentVersion === 'v1'">
                <button type="button" :disabled="isWorking" @click="saveBankAccount"
                  v-if="store.state.user.permissions.includes('USER.UPDATE_BANK_ACCOUNT') && store.state.selectedOperator.paymentVersion === 'v1'"
                  class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm">
                  {{ $t(`messages.player.id.saveBankAccount`) }}
                </button>
                <button type="button" @click="toggleEditBankAccountModal"
                  v-if="store.state.user.permissions.includes('USER.UPDATE_BANK_ACCOUNT') && store.state.selectedOperator.paymentVersion === 'v1'"
                  class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                  ref="cancelButtonRef">
                  {{ $t(`messages.player.id.cancel`) }}
                </button>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
    <TransitionRoot as="template" :show="editBankAccountV2Open">
      <Dialog as="div" static class="fixed z-10 inset-0 overflow-y-auto" @close="editBankAccountV2Open = false"
        :open="editBankAccountV2Open">
        <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
            leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div
              class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6">
              <div>
                <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                  <font-awesome-icon class="text-green-600" :icon="['far', 'money-check-edit']" transform="grow-2" />
                </div>
                <div class="mt-3 text-center sm:mt-5">
                  <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                    {{ $t(`messages.player.id.editBankAcountV2`) }}
                    <!-- <small class="text-gray-400">{{ userInfo.username }}</small> -->
                  </DialogTitle>
                  <div class="mt-8 pb-2 text-left">
                    <div>
                      <label for="location" class="block text-sm font-medium text-gray-700">
                        {{ $t(`messages.player.id.selectBank`) }}</label>
                      <select id="location" name="location" v-model="bankAccount.bank"
                        class="capitalize mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md">
                        <option v-for="bank in bankList" :key="bank.bankCode" :value="bank.bankCode">
                          {{ bank.description }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="mt-2 pb-2 text-left">
                    <div class="mt-1">
                      <label for="location" class="block text-sm font-medium text-gray-700">
                        {{ $t(`messages.player.id.accountNumber`) }}</label>
                      <input type="text" v-model="bankAccount.accountNumber" name="newPassword" id="newPassword"
                        class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        :placeholder="$t(`messages.player.id.accountNumber`)" />
                      <label v-if="isAlertBank" class="block text-sm font-medium text-red-500">
                        {{ alertMessage }}</label>
                    </div>
                  </div>
                  <div class="mt-2 pb-2 text-left">
                    <label for="location" class="block text-sm font-medium text-gray-700">
                      {{ $t(`messages.player.id.accountName`) }}</label>
                    <input type="text" v-model="accountName" name="accountName" id="accountName"
                      class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                      :placeholder="$t(`messages.player.id.accountName`)" />
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
                v-if="store.state.user.permissions.includes('PAYMENT_CONFIG.USER.UPDATE_BANK_ACCOUNT') && store.state.selectedOperator.paymentVersion !== 'v1'">
                <button type="button" :disabled="isWorking" @click="saveBankAccountV2"
                  v-if="store.state.user.permissions.includes('PAYMENT_CONFIG.USER.UPDATE_BANK_ACCOUNT') && store.state.selectedOperator.paymentVersion !== 'v1'"
                  class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm">
                  {{ $t(`messages.player.id.saveBankAccount`) }}
                </button>
                <button type="button" @click="toggleEditBankAccountV2Modal"
                  v-if="store.state.user.permissions.includes('PAYMENT_CONFIG.USER.UPDATE_BANK_ACCOUNT') && store.state.selectedOperator.paymentVersion !== 'v1'"
                  class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                  ref="cancelButtonRef">
                  {{ $t(`messages.player.id.cancel`) }}
                </button>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
    <TransitionRoot as="template" :show="forceEditBankAccountV2Open">
      <Dialog as="div" static class="fixed z-10 inset-0 overflow-y-auto" @close="forceEditBankAccountV2Open = false"
        :open="forceEditBankAccountV2Open">
        <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
            leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div
              class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6">
              <div>
                <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                  <font-awesome-icon class="text-green-600" :icon="['far', 'money-check-edit']" transform="grow-2" />
                </div>
                <div class="mt-3 text-center sm:mt-5">
                  <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                    {{ $t(`messages.player.id.forceEditBankAcountV2`) }}
                    <!-- <small class="text-gray-400">{{ userInfo.username }}</small> -->
                  </DialogTitle>
                  <div class="mt-8 pb-2 text-left">
                    <div>
                      <label for="location" class="block text-sm font-medium text-gray-700">
                        {{ $t(`messages.player.id.selectBank`) }}</label>
                      <select id="location" name="location" v-model="bankAccount.bank"
                        class="capitalize mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md">
                        <option v-for="bank in bankList" :key="bank.bankCode" :value="bank.bankCode">
                          {{ bank.description }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="mt-2 pb-2 text-left">
                    <div class="mt-1">
                      <label for="location" class="block text-sm font-medium text-gray-700">
                        {{ $t(`messages.player.id.accountNumber`) }}</label>
                      <input type="text" v-model="bankAccount.accountNumber" name="newPassword" id="newPassword"
                        class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        :placeholder="$t(`messages.player.id.accountNumber`)" />
                      <label v-if="isAlertBank" class="block text-sm font-medium text-red-500">
                        {{ alertMessage }}</label>
                    </div>
                  </div>
                  <div class="mt-2 pb-2 text-left">
                    <label for="location" class="block text-sm font-medium text-gray-700">
                      {{ $t(`messages.player.id.accountName`) }}</label>
                    <input type="text" v-model="accountName" name="accountName" id="accountName"
                      class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                      :placeholder="$t(`messages.player.id.accountName`)" />
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
                v-if="store.state.user.permissions.includes('PAYMENT_CONFIG.USER.UPDATE_BANK_ACCOUNT') && store.state.selectedOperator.paymentVersion !== 'v1'">
                <button type="button" :disabled="isWorking" @click="saveFoceBankAccountV2"
                  v-if="store.state.user.permissions.includes('PAYMENT_CONFIG.USER.UPDATE_BANK_ACCOUNT') && store.state.selectedOperator.paymentVersion !== 'v1'"
                  class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm">
                  {{ $t(`messages.player.id.saveBankAccount`) }}
                </button>
                <button type="button" @click="toggleForceEditBankAccountV2Modal"
                  v-if="store.state.user.permissions.includes('PAYMENT_CONFIG.USER.UPDATE_BANK_ACCOUNT') && store.state.selectedOperator.paymentVersion !== 'v1'"
                  class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                  ref="cancelButtonRef">
                  {{ $t(`messages.player.id.cancel`) }}
                </button>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
    <TransitionRoot as="template" :show="forceEditBankAccountOpen">
      <Dialog as="div" static class="fixed z-10 inset-0 overflow-y-auto" @close="forceEditBankAccountOpen = false"
        :open="forceEditBankAccountOpen">
        <div class="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
            leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </TransitionChild>

          <!-- This element is to trick the browser into centering the modal contents. -->
          <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
          <TransitionChild as="template" enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div
              class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-md sm:w-full sm:p-6">
              <div>
                <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                  <font-awesome-icon class="text-green-600" :icon="['far', 'money-check-edit']" transform="grow-2" />
                </div>
                <div class="mt-3 text-center sm:mt-5">
                  <DialogTitle as="h3" class="text-lg leading-6 font-medium text-gray-900">
                    {{ $t(`messages.player.id.forceEditBankAccount`) }}
                    <!-- <small class="text-gray-400">{{ userInfo.username }}</small> -->
                  </DialogTitle>
                  <div class="mt-8 pb-2 text-left">
                    <div>
                      <label for="location" class="block text-sm font-medium text-gray-700">
                        {{ $t(`messages.player.id.selectBank`) }}</label>
                      <select id="location" name="location" v-model="bankAccount.bank"
                        class="capitalize mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md">
                        <option v-for="bank in bankList" :key="bank.bankCode" :value="bank.bankCode">
                          {{ bank.description }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="mt-2 pb-2 text-left">
                    <div class="mt-1">
                      <label for="location" class="block text-sm font-medium text-gray-700">
                        {{ $t(`messages.player.id.accountNumber`) }}</label>
                      <input type="text" v-model="bankAccount.accountNumber" name="newPassword" id="newPassword"
                        class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        :placeholder="$t(`messages.player.id.accountNumber`)" />
                      <label v-if="isAlertBank" class="block text-sm font-medium text-red-500">
                        {{ alertMessage }}</label>
                    </div>
                  </div>
                  <div class="mt-2 pb-2 text-left">
                    <label for="location" class="block text-sm font-medium text-gray-700">
                      {{ $t(`messages.player.id.accountName`) }}</label>
                    <input type="text" v-model="accountName" name="accountName" id="accountName"
                      class="shadow-sm focus:ring-blue-500 focus:border-blue-500 block w-full sm:text-sm border-gray-300 rounded-md"
                      :placeholder="$t(`messages.player.id.accountName`)" />
                  </div>
                </div>
              </div>
              <div class="mt-5 sm:mt-6 sm:grid sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense"
                v-if="store.state.user.permissions.includes('PAYMENT_CONFIG.USER.UPDATE_BANK_ACCOUNT') && store.state.selectedOperator.paymentVersion == 'v1'">
                <button type="button" :disabled="isWorking" @click="saveForceBankAccount"
                  v-if="store.state.user.permissions.includes('PAYMENT_CONFIG.USER.UPDATE_BANK_ACCOUNT') && store.state.selectedOperator.paymentVersion == 'v1'"
                  class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-blue-600 text-base font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:col-start-2 sm:text-sm">
                  {{ $t(`messages.player.id.saveBankAccount`) }}
                </button>
                <button type="button" @click="toggleForceEditBankAccountModal"
                  v-if="store.state.user.permissions.includes('PAYMENT_CONFIG.USER.UPDATE_BANK_ACCOUNT') && store.state.selectedOperator.paymentVersion == 'v1'"
                  class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 sm:mt-0 sm:col-start-1 sm:text-sm"
                  ref="cancelButtonRef">
                  {{ $t(`messages.player.id.cancel`) }}
                </button>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </TransitionRoot>
    <dialog-component :isOpen="isEditFail" :title="failedTitle">
      <div class="text-center p-4">
        <p>{{ failedMessage }}</p>
      </div>

      <div class="text-center">
        <button @click="isEditFail = false" class="bg-red-500 text-white p-2 w-24 uppercase rounded">
          {{ $t(`messages.player.id.ok`) }}
        </button>
      </div>
    </dialog-component>
    <!--  Manual Deposit V2  -->
    <DepositWithdrawDialog v-model:value="manualPaymentDepositValueV2" v-model:date="depositDateV2" v-model:payment="manualPaymentDepositPaymentIdV2"
      v-model:open="isShowManualPaymentDepositV2" v-model:error-text="manualPaymentDepositErrorTextV2"
      @submit="onManualPaymentDepositV2" v-model:note="manualPaymentDepositNoteV2"/>
    <DepositWithdrawDialog v-model:value="manualPaymentWithdrawValueV2" v-model:date="depositDateV2" v-model:payment="manualPaymentDepositPaymentIdV2"
      v-model:open="isShowManualPaymentWithdrawV2" v-model:error-text="manualPaymentWithdrawErrorTextV2"
      :is-withdraw="true" @submit="onManualPaymentWithdrawV2" v-model:note="manualPaymentWithdrawNoteV2"/>
    <QrCodeManualDepositDialog v-model:qrCodeText="qrCodeText" v-model:open="isShowQrManualDeposit"
      v-model:amount="qrAmount" v-model:expired-at="qrCodeExpiredAt" />
    <DepositWithdrawDialog v-model:value="manualPaymentDepositValue" v-model:date="depositDate"
      v-model:open="isShowManualPaymentDeposit" v-model:error-text="manualPaymentDepositErrorText"
      @submit="onManualPaymentDeposit" />
    <DepositWithdrawDialog v-model:value="qrDepositAmount" v-model:open="isShowQRDeposit" @submit="onQRDeposit" />
    <DepositWithdrawDialog v-if="store.state.selectedOperator?.paymentAccountTypes?.includes('MANUAL') &&
      store.state.user.permissions.includes('USER.MANUAL_WITHDRAW_CREATE')" isWithdraw
      v-model:value="manualPaymentDepositValue" v-model:date="depositDate" v-model:open="isShowManualPaymentWithdraw"
      @submit="onManualPaymentWithdraw" />
    <!-- <dialog-component
      :isOpen="isShowManualPaymentDeposit"
      title="Manual Payment Deposit"
    >
      <div class="text-center p-4 w-full">
        <input
          type="number"
          class="rounded"
          placeholder="จำนวนบาท"
          v-model="manualPaymentDepositValue"
        />
      </div>
      <div class="text-center w-full">
        {{ $t(`messages.player.id.depositDate`) }}
        <div class="p-4">
          <input
            id="depositDate"
            v-model="depositDate"
            placeholder="Deposit Date"
            type="datetime-local"
            :max="dayjs().format().slice(0, -6)"
            class="rounded"
            name="depositDate"
            @update:model-value="onCheckFuture"
          />
        </div>
      </div>
      <div class="flex-col flex items-center">
        <div class="flex flex-row flex-wrap flex-1 gap-0 justify-center">
          <div class="relative">
            <button
              class="bg-blue-400 mt-2 p-1 capitalize text-white rounded mb-1 focus:ring"
              @click="$refs.file.click()"
            >
              <font-awesome-icon :icon="['far', 'file-alt']" />
              {{ $t("messages.rewardCategory.upload") }}
            </button>
          </div>
        </div>
        <input type="file" ref="file" class="hidden" @change="onFileSelected" />
        <input
          v-if="!preview"
          type="text"
          placeholder="Click to upload"
          class="rounded border-dashed border-2 cursor-pointer"
          v-model="imageUrl"
          @click="$refs.file.click()"
        />
        <div v-else>
          <p class="mr-24">
            {{ $t("messages.rewardCategory.previewImage") }}
          </p>
          <img :src="preview" class="mx-auto w-52 h-52 object-contain" />
        </div>
      </div>
      <div class="row text-center">
        <button
          @click="isShowManualPaymentDeposit = false"
          class="m-1 p-2 bg-red-500 rounded text-white"
        >
          {{ $t(`messages.player.id.cancel`) }}
        </button>
        <button
          class="m-1 p-2 bg-blue-500 rounded text-white"
          @click="onManualPaymentDeposit"
        >
          {{ $t(`messages.player.id.deposit`) }}
        </button>
      </div>
    </dialog-component>
    <dialog-component
      :isOpen="isShowManualPaymentWithdraw"
      title="Manual Payment Withdraw"
    >
      <div class="text-center p-4 w-full">
        <input
          type="number"
          class="rounded"
          placeholder="จำนวนบาท"
          v-model="manualPaymentDepositValue"
        />
      </div>
      <div class="text-center w-full">
        {{ $t(`messages.player.id.depositDate`) }}
        <div class="p-4">
          <input
            id="depositDate"
            v-model="depositDate"
            placeholder="Withdraw Date"
            type="datetime-local"
            :max="dayjs().format().slice(0, -6)"
            class="rounded"
            name="depositDate"
            @update:model-value="onCheckFuture"
          />
        </div>
      </div>
      <div class="row text-center">
        <button
          @click="isShowManualPaymentWithdraw = false"
          class="m-1 p-2 bg-red-500 rounded text-white"
        >
          {{ $t(`messages.player.id.cancel`) }}
        </button>
        <button
          class="m-1 p-2 bg-blue-500 rounded text-white"
          @click="onManualPaymentDeposit"
        >
          {{ $t(`messages.player.id.deposit`) }}
        </button>
      </div>
    </dialog-component> -->
    <ManualTopupPointDialog v-model:show="isManualTopupPoint" v-model:form="userInfo" @topup="refetch()" />
    <UsernameUpdateRequestDialog v-model:show="isUsernameUpdate" v-model:form="userInfo" />

    <UpdateRedeemLimit v-model:show="isUpdateRedeemLimit" v-model:redeemLimit="userInfo.redeemLimitPerDay"
      v-model:userId="userInfo.id" v-model:userName="userInfo.username" @update-redeem-limit="refetch()" />
  </div>
  <dialog-component :title="suspendData.isActive ? 'Confirm Suspend User' : 'Confirm Activate User'"
    :isOpen="isSuspend">
    <div class="px-8 py-4 uppercase">
      <p>{{ $t(`messages.player.id.id`) }}: {{ suspendData.id }}</p>
      <p>{{ $t(`messages.player.id.username`) }}: {{ suspendData.username }}</p>
      <p>{{ $t(`messages.player.id.name`) }}: {{ suspendData.firstName }}</p>
      <p>
        {{ $t(`messages.player.id.phoneNumber`) }}:
        {{ suspendData.phoneNumber }}
      </p>
      <p>{{ $t(`messages.player.id.reason`) }}:
        <textarea class="w-full rounded" v-model="reason"></textarea>
      </p>
    </div>
    <div class="mt-3 flex row justify-around">
      <button class="bg-blue-500 uppercase rounded-lg text-white p-2" @click="onSuspendUser(suspendData.id)">
        {{ $t(`messages.player.id.confirm`) }}
      </button>
      <button class="bg-red-600 rounded-lg uppercase text-white p-2" @click="() => {
        isSuspend = !isSuspend;
        refetch();
      }
      ">
        {{ $t(`messages.player.id.cancel`) }}
      </button>
    </div>
  </dialog-component>
  <CreateTicketBaseDialog v-model:loading="formLoading" v-model:show="showCreateTicketModal"
    @onCreateTicket="onCreateTicket" :userInfo="userInfo" :isPlayer="isPlayer" />
  <Toast v-model:show="toastConfig.show" :message="toastConfig.message" :success="toastConfig.success"
    :warning="toastConfig.warning" :manual_close="toastConfig.manual_close" />
</template>

<script>
import {
  CheckCircleIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  MailIcon,
  HomeIcon,
  SearchIcon,
  PhoneIcon,
} from "@heroicons/vue/solid";
import {
  Dialog,
  DialogOverlay,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";
import { inject, onMounted, ref, watch } from "@vue/runtime-core";
import { useStore } from "vuex";
import * as dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { useRoute } from "vue-router";
import jwt_decode from "jwt-decode";
import { Switch } from "@headlessui/vue";
import { useRouter } from "vue-router";
import { camalize } from "@/utils/tools";

import DialogComponent from "@/components/doalog/DialogComponent.vue";
import ManualTopupPointDialog from "@/components/dialogs/ManualTopupPointDialog.vue";
import UsernameUpdateRequestDialog from "@/components/dialogs/UsernameUpdateRequestDialog.vue";
import UpdateRedeemLimit from "@/components/dialogs/UpdateRedeemLimit.vue";
import DepositWithdrawDialog from "@/components/dialogs/DepositWithdrawDialog.vue";
import { PaymentAccount } from "@/views/payment-config/PaymentConfig";
import CreateTicketBaseDialog from "@/components/dialogs/ticket-managements/CreateTicketBaseDialog.vue";
import Toast from '@/components/tools/Toast.vue'
import { check_require_field } from '@/utils/ticket-validator'
import QrCodeManualDepositDialog from "@/components/dialogs/QrCodeManualDepositDialog.vue";
dayjs.extend(localizedFormat);

const pages = [{ name: "Players", href: "", current: true }];

export default {
  components: {
    QrCodeManualDepositDialog,
    ChevronLeftIcon,
    ChevronRightIcon,
    CheckCircleIcon,
    MailIcon,
    HomeIcon,
    SearchIcon,
    PhoneIcon,
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
    DialogComponent,
    Switch,
    ManualTopupPointDialog,
    UsernameUpdateRequestDialog,
    UpdateRedeemLimit,
    DepositWithdrawDialog,
    CreateTicketBaseDialog,
    Toast,
  },
  setup() {
    const axios = inject("$axios");
    const store = useStore();
    const route = useRoute();
    const changePasswordOpen = ref(false);
    const editBankAccountOpen = ref(false);
    const editBankAccountV2Open = ref(false);
    const forceEditBankAccountV2Open = ref(false);
    const forceEditBankAccountOpen = ref(false);
    const isWorking = ref(false);
    const isEditFail = ref(false);
    let pages = ref([{ name: "Players", href: "", current: true }]);
    const isShowManualPaymentDeposit = ref(false);
    const isShowManualPaymentWithdraw = ref(false);
    const manualPaymentDepositValue = ref();
    const manualPaymentDepositErrorText = ref();
    const qrDepositAmount = ref();
    const isShowQRDeposit = ref(false);
    const depositDate = ref(dayjs().format().slice(0, -9));
    const depositDateV2 = ref(dayjs().format().slice(0, -9));
    const isShowQrManualDeposit = ref(false);
    const qrCodeText = ref()
    const qrAmount = ref()
    const qrCodeExpiredAt = ref()
    const failedTitle = ref("ผิดพลาด");
    const failedMessage = ref(
      "ไม่สามารถแก้ไขบัญชีได้"
    );
    const userRoles = ref();
    const isUpdateRedeemLimit = ref(false);
    const isAffiliateUser = ref(false);
    const affiliateUserRole = "Customer Affiliate Dashboard";
    const isManualTopupPoint = ref(false);
    const isUsernameUpdate = ref(false);
    const reason = ref("");
    const router = useRouter();
    const userActivityLogs = ref("");
    const showCreateTicketModal = ref(false)
    const formLoading = ref(false)
    const manualPaymentDepositValueV2 = ref()
    const manualPaymentDepositNoteV2 = ref()
    const manualPaymentDepositPaymentIdV2 = ref({ label: "-Select-", value: null })
    const manualPaymentWithdrawValueV2 = ref()
    const manualPaymentWithdrawNoteV2 = ref()
    const manualPaymentDepositErrorTextV2 = ref()
    const manualPaymentWithdrawErrorTextV2 = ref()
    const isShowManualPaymentDepositV2 = ref(false)
    const isShowManualPaymentWithdrawV2 = ref(false)
    const processedApproval = ref(false)
    const toastConfig = ref({
      show: false,
      message: '',
      success: true,
      manual_close: false,
    })
    let isAlertBank = ref(false)
    let alertMessage = ref("")
    const onCheckFuture = (e) => {
      const now = dayjs(Date.now());
      const diff = now.diff(e, "second");
      if (diff > 0) return;
      else depositDate.value = dayjs(now).format("YYYY-MM-DDTHH:mm");
    };
    const isSuspend = ref(false);
    const suspendData = ref({});
    const updateSuspendData = (data) => {
      suspendData.value = data;
      isSuspend.value = !isSuspend.value;
    };
    let tabs = ref([
      {
        name: "Wallet Info",
        href: { name: "Wallet Info", params: { id: route.params.id } },
        route: "Wallet Info",
      },
      // {
      //   name: "Bet Limit",
      //   href: { name: "Player Bet Limit", params: { id: route.params.id } },
      //   route: "Player Bet Limit",
      // },
      {
        name: "Affiliate Info",
        href: {
          name: "Player Affiliate Info",
          params: { id: route.params.id },
        },
        route: "Player Affiliate Info",
      },
      {
        name: "Topup/Withdraw Records",
        href: {
          name: "Player Wallet Transaction",
          params: { id: route.params.id },
        },
        route: "Player Wallet Transaction",
      },
      {
        name: "Game Records",
        href: { name: "Player Game Records", params: { id: route.params.id } },
        route: "Player Game Records",
      },
      {
        name: "Player Login",
        href: { name: "Player Login", params: { id: route.params.id } },
        route: "Player Login",
      },
      {
        name: "Commission Info",
        href: { name: "Commission Info", params: { id: route.params.id } },
        route: "Commission Info",
      },
      {
        name: "Loyalty Info",
        href: { name: "Player Loyalty Info", params: { id: route.params.id } },
        route: "Player Loyalty Info",
      },
      {
        name: "Quest",
        href: { name: "User Event", params: { id: route.params.id } },
        route: "User Event",
      },
      {
        name: "User Transaction Summaries",
        href: { name: "User Transaction Summaries", params: { id: route.params.id } },
        route: "User Transaction Summaries",
      },
    ]);

    let userInfo = ref({});
    let transactions = ref([]);
    let bankList = ref([
      {
        bankCode: "",
        description: "-- Select Bank --",
      },
      // {
      //   bankCode: "KBANK",
      //   description: "Kasikorn bank",
      // },
      // {
      //   bankCode: "SCB",
      //   description: "Siam commercial bank",
      // },
      // {
      //   bankCode: "KTB",
      //   description: "Krung Thai bank",
      // },
      // {
      //   bankCode: "BBL",
      //   description: "Bangkok Bank",
      // },
      // {
      //   bankCode: "BAY",
      //   description: "Krungsri Bank",
      // },
      // {
      //   bankCode: "TTB",
      //   description: "Thai Military Thanachart Bank",
      // },
      // {
      //   bankCode: "LHBANK",
      //   description: "LH Bank",
      // },
      // {
      //   bankCode: "IBANK",
      //   description: "Islam Bank",
      // },
      // {
      //   bankCode: "UOB",
      //   description: "UOB Bank",
      // },
      // {
      //   bankCode: "GSB",
      //   description: "Government Saving Bank",
      // },
      // {
      //   bankCode: "BAAC",
      //   description: "BAAC",
      // },
      // {
      //   bankCode: "CIMB",
      //   description: "CIMB",
      // },
      // {
      //   bankCode: "GHBANK",
      //   description: "GHBANK",
      // },
      // {
      //   bankCode: "KK",
      //   description: "Kiatnakin bank",
      // },
      // {
      //   bankCode: "PSV",
      //   description: "Phongsavanh Bank",
      // },
      // {
      //   bankCode: "LDB",
      //   description: "Lao Development Bank",
      // },
      // {
      //   bankCode: "APB",
      //   description: "Agricultural Promotion Bank",
      // },
      // {
      //   bankCode: "JDB",
      //   description: "Joint Development Bank",
      // },
      // {
      //   bankCode: "BCEL",
      //   description: "Banque Pour Le Commerce Exterieur Lao Public",
      // },
      // {
      //   bankCode: "LVB",
      //   description: "LAO VIET BANK",
      // },
      // {
      //   bankCode: "STB",
      //   description: "ST Bank Laos",
      // },
      // {
      //   bankCode: "LPDR",
      //   description: "Lao PDR",
      // },
      // {
      //   bankCode: "SACB",
      //   description: "Sacombank",
      // },
      // {
      //   bankCode: "IDCB",
      //   description: "Indochina Bank",
      // },
      // {
      //   bankCode: "VIB",
      //   description: "Vietinbank",
      // },
    ]);

    let newPassword = ref("");
    let accountName = ref("");
    let bankAccount = ref({
      bank: bankList.value[0].bankCode,
      accountNumber: "",
    });

    let isLoaded = ref(false);
    const isPlayer = ref(true)
    // upload file handler
    const file = ref();
    const preview = ref("");
    const imageUrl = ref("");
    const onFileSelected = async () => {
      // const reader = new FileReader();
      const formData = new FormData();
      const files = file.value.files;

      formData.append("file", files[0]);
      formData.append("mimeType", files[0]?.type);
      formData.append("uploadType", "slip");
      formData.append(
        "fileName",
        `${dayjs().format("YYYY-MM-DD_hh:mm:ss")}_${files[0].name}`
      );
      try {
        const image = await uploadPic(formData);
        if (image && image.data.imageUrl) {
          preview.value = image.data.imageUrl;
        }
      } catch (error) {
        alert(error);
      }
    };
    const uploadPic = async (formData) => {
      const data = await axios.post(
        `${process.env.VUE_APP_API_ENDPOINT}/upload/api/internal/image`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      // await axios.post(
      //   `${process.env.VUE_APP_API_ENDPOINT}/get/api/internal/presigned`,
      //   { key: data.data.presignedUrl }
      // );
      return data;
    };

    onMounted(async () => {
      if (store.state.selectedOperator.paymentVersion !== 'v1') {
        tabs.value.splice(4, 0, {
          name: "Player Config V2",
          href: { name: "Player Config V2", params: { id: route.params.id } },
          route: "Player Config V2",
        })

      } else {
        tabs.value.splice(4, 0, {
          name: "Player Config",
          href: { name: "Player Config", params: { id: route.params.id } },
          route: "Player Config",
        })
      }

      refetch();
    });

    const selected_tab = ref("Wallet Info");
    const changePage = () => {
      const selected_page = tabs.value.find(
        ({ name }) => name == selected_tab.value
      );
      router.push(selected_page.href);
    };

    const refetch = () => {
      Promise.all([
        axios.post(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/user/read`,
          {
            operatorId: store.state.selectedOperator.operatorId,
            userId: route.params.id,
          }
        ),
        axios.post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/loyalty/api/internal/user/read",
          {
            operatorId: store.state.selectedOperator.operatorId,
            userId: route.params.id,
          }
        ),
        axios.post(process.env.VUE_APP_API_ENDPOINT + "/admin/api/v1/loyalty/api/internal/point",
          {
            userId: route.params.id,
          }
        ),
      ])
        .then((res) => {
          if (Object.keys(res[0].data.result).length) {
            userInfo.value = res[0].data.result[0];
            userInfo.value.redeemLimitPerDay = res[1].data.redeemLimitPerDay;
            userInfo.value.loyalty = res[2].data;
          } else {
            userInfo.value.id = undefined;
          }
          isLoaded.value = true;
          if (!userInfo.value) {
            return;
          }
          if (userInfo.value.userRoles) {
            userRoles.value = userInfo.value.userRoles.map((arr) =>
              arr.is_active ? arr.name : null
            );
            isAffiliateUser.value =
              userRoles.value && userRoles.value.includes(affiliateUserRole);
          }

          accountName.value = userInfo.value.accountNameTh || userInfo.value.accountNameEn

          pages.value = [
            { name: "Players", href: { name: "Player List" }, current: false },
            { name: userInfo.value.username, href: "", current: false },
          ];

          if (userInfo.value && userInfo.value.id && !userInfo.value.isActive) {
            console.log('get user data');
            const payload = {
              operatorId: store.state.selectedOperator.operatorId,
              page: 1,
              limit: 1,
              offset: 0,
              sortBy: [["createdAt", -1]],
              userId: userInfo.value.id,
              updatedField: "user isActive status",
            };
            const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/user-activity-logs/list`;
            axios.post(url, payload)
              .then(({ data }) => userActivityLogs.value = data.result[0])
              .catch((err) => {
                console.log(err);
              });
          }
          
          // isSuspend.value = !userInfo.value.isActive

        })
        .catch((err) => {
          console.log(err);
        });

      const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/banks`;
      const banksPayload = {
        "requestId": Date.now(),
        "requestTs": Date.now(),
        "is_active": true
      }

      axios.post(url, banksPayload).then(({ data }) => {
        bankList.value = (data.map(bank => ({
          bankCode: bank.bank_code,
          description: `${bank.name_th} (${bank.bank_code})`,
          nameTh: bank.name_th,
          name: bank.name
        })))
        bankList.value.unshift(
          {
            bankCode: "",
            description: "-- Select Bank --",
          })
      }).catch((err) => {
        console.log(err);
      });
    };

    const toggleChangePasswordModal = () => {
      changePasswordOpen.value = !changePasswordOpen.value;
    };

    const toggleEditBankAccountModal = () => {
      editBankAccountOpen.value = !editBankAccountOpen.value;
    };

    const toggleEditBankAccountV2Modal = () => {
      editBankAccountV2Open.value = !editBankAccountV2Open.value;
    };

    const toggleForceEditBankAccountV2Modal = () => {
      forceEditBankAccountV2Open.value = !forceEditBankAccountV2Open.value;
    };

    const toggleForceEditBankAccountModal = () => {
      forceEditBankAccountOpen.value = !forceEditBankAccountOpen.value;
    };
    const saveBankAccount = () => {
      isWorking.value = true;
      if (!bankAccount.value.bank || !bankAccount.value.accountNumber || !accountName.value) {
        const message = 'Missing bank information!';
        alert(message);
        isWorking.value = false;
        return
      }

      if (!/^\d+$/.test(bankAccount.value.accountNumber)) {
        alert('กรุณากรอกเฉพาะตัวเลข')
        return
      }

      let body = {
        requestId: `${Date.now()}`,
        requestTs: Date.now(),
        operatorId: store.state.selectedOperator.operatorId,
        userId: userInfo.value.id,
        accountName: accountName.value,
        accountNumber: bankAccount.value.accountNumber,
        bankName: bankList.value.find((b) => b.bankCode == bankAccount.value.bank).nameTh,
        bankCode: bankAccount.value.bank,
        name: accountName.value,
        forceCheck: false
      };

      const updateBankAccountEndpoint =
        store.state.selectedOperator.paymentAccountTypes.includes("WOWSPAY") ? '/admin/api/v1/operator-admin/user/update-bank-account/non-user-payment-account'
          : store.state.selectedOperator.paymentAccountTypes.includes("MANUAL") ? '/admin/api/v1/operator-admin/user/manual-update-bank-account'
            : '/admin/api/v1/operator-admin/user/update-bank-account'

      // console.log('updateBankAccountEndpoint', updateBankAccountEndpoint);
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + updateBankAccountEndpoint,
          body
        )
        .then(() => {
          isEditFail.value = false;
          isWorking.value = false;
          editBankAccountOpen.value = false;
          refetch();
          setTimeout(() => {
            newPassword.value = null;
          }, 1000);
        })
        .catch((err) => {
          if (err.response.data.message.includes("Invalidbank")) {
            failedTitle.value = `ไม่พบบัญชีธนาคาร`;
            failedMessage.value = `ไม่สามารถแก้ไขบัญชีได้ เนื่องจากไม่พบบัญชีธนาคารดังกล่าวในระบบ`;
          } else if (err.response.data.message.includes("Duplicate")) {
            failedTitle.value = "บัญชีซ้ำในระบบ";
            failedMessage.value =
              "ไม่สามารถแก้ไขบัญชีได้ เนื่องจากมีบัญชีซ้ำในระบบ";
          } else {
            failedTitle.value = "ผิดพลาด";
            failedMessage.value =
              "ไม่สามารถแก้ไขบัญชีได้ " + err.response.data.message;
          }
          isEditFail.value = true;
          isWorking.value = false;
          // editBankAccountOpen.value = false;
          setTimeout(() => {
            newPassword.value = null;
          }, 1000);
        });
    };

    const saveForceBankAccount = () => {
      isWorking.value = true;
      if (!bankAccount.value.bank || !bankAccount.value.accountNumber || !accountName.value) {
        const message = 'Missing bank information!';
        alert(message);
        isWorking.value = false;
        return
      }

      if (!/^\d+$/.test(bankAccount.value.accountNumber)) {
        alert('กรุณากรอกเฉพาะตัวเลข')
        return
      }

      let body = {
        requestId: `${Date.now()}`,
        requestTs: Date.now(),
        operatorId: store.state.selectedOperator.operatorId,
        userId: userInfo.value.id,
        accountName: accountName.value,
        accountNumber: bankAccount.value.accountNumber,
        bankName: bankList.value.find((b) => b.bankCode == bankAccount.value.bank).nameTh,
        bankCode: bankAccount.value.bank,
        name: accountName.value,
        forceCheck: false
      };

      const updateBankAccountEndpoint =
        store.state.selectedOperator.paymentAccountTypes.includes("WOWSPAY") ? '/admin/api/v1/operator-admin/user/update-bank-account/non-user-payment-account'
          : store.state.selectedOperator.paymentAccountTypes.includes("MANUAL") ? '/admin/api/v1/operator-admin/user/manual-update-bank-account'
            : '/admin/api/v1/operator-admin/user/update-bank-account'

      // console.log('updateBankAccountEndpoint', updateBankAccountEndpoint);
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + updateBankAccountEndpoint,
          body
        )
        .then(() => {
          isEditFail.value = false;
          isWorking.value = false;
          forceEditBankAccountOpen.value = false;
          refetch();
          setTimeout(() => {
            newPassword.value = null;
          }, 1000);
        })
        .catch((err) => {
          if (err.response.data.message.includes("Invalidbank")) {
            failedTitle.value = `ไม่พบบัญชีธนาคาร`;
            failedMessage.value = `ไม่สามารถแก้ไขบัญชีได้ เนื่องจากไม่พบบัญชีธนาคารดังกล่าวในระบบ`;
          } else if (err.response.data.message.includes("Duplicate")) {
            failedTitle.value = "บัญชีซ้ำในระบบ";
            failedMessage.value =
              "ไม่สามารถแก้ไขบัญชีได้ เนื่องจากมีบัญชีซ้ำในระบบ";
          } else {
            failedTitle.value = "ผิดพลาด";
            failedMessage.value =
              "ไม่สามารถแก้ไขบัญชีได้ " + err.response.data.message;
          }
          isEditFail.value = true;
          isWorking.value = false;
          // editBankAccountOpen.value = false;
          setTimeout(() => {
            newPassword.value = null;
          }, 1000);
        });
    };

    const saveBankAccountV2 = () => {
      isWorking.value = true;
      if (!bankAccount.value.bank || !bankAccount.value.accountNumber || !accountName.value) {
        const message = 'Missing bank information!';
        alert(message);
        isWorking.value = false;
        return
      }

      if (!/^\d+$/.test(bankAccount.value.accountNumber)) {
        alert('กรุณากรอกเฉพาะตัวเลข')
        return
      }

      let body = {
        requestId: `${Date.now()}`,
        requestTs: Date.now(),
        operatorId: store.state.selectedOperator.operatorId,
        userId: userInfo.value.id,
        accountNumber: `${bankAccount.value.accountNumber}`,
        bankName: bankList.value.find((b) => b.bankCode == bankAccount.value.bank).nameTh,
        bankCode: bankAccount.value.bank,
        name: accountName.value
      };
      const updateBankAccountEndpoint = '/admin/api/v1/operator-admin/v2/user/update-bank-account'
      // console.log('updateBankAccountEndpoint', updateBankAccountEndpoint);
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + updateBankAccountEndpoint,

          body
        )
        .then((data) => {
          let findError = []
          if (Array.isArray(data.data.payload)) {
            data.data.payload.map((payload) => {
              if (payload.success == false) findError.push(payload.paymentName)
            })
          }
          toastConfig.value.show = true
          toastConfig.value.manual_close = true
          if (data.data.success === false) {
            if(data.data.message.includes('Invalidbank')){
              failedTitle.value = `ไม่พบบัญชีธนาคาร`;
              failedMessage.value = `ไม่สามารถแก้ไขบัญชีได้ เนื่องจากไม่พบบัญชีธนาคารดังกล่าวในระบบ`;
              toastConfig.value.show = false
              isEditFail.value = true;
              return
            }
            isAlertBank.value = true
            alertMessage.value = data.data?.payload?.message || 'Update Failed Please Check Bank Account Again'
            toastConfig.value.success = false
            toastConfig.value.message = `Update Failed!!`
          }
          else if (findError.length > 0 && data.data.success == true) {
            toastConfig.value.warning = true
            if (Array.isArray(data.data.payload)) {
              toastConfig.value.message = [...data.data.payload.map((payload) => {
                return `[${payload.paymentName} update: ${payload.success ? `SUCCESS` : `FAILED`}]`
              }), 'กรุณาติดต่อ Support team เพื่อแก้ไข'].join(`,`)
            }
            editBankAccountV2Open.value = false;
          }
          else {
            toastConfig.value.success = true
            toastConfig.value.message = `Update Success!!`
            editBankAccountV2Open.value = false;
          }

          isEditFail.value = false;
          isWorking.value = false;
          refetch();
          setTimeout(() => {
            newPassword.value = null;
          }, 1000);
        })
        .catch((err) => {
          failedTitle.value = "แก้บัญชีล้มเหลว";
          failedMessage.value =
            "ไม่สามารถแก้ไขบัญชีได้";
          if (err.response.data.message) {
            if (err.response.data.message.includes("Invalidbank")) {
              failedTitle.value = `ไม่พบบัญชีธนาคาร`;
              failedMessage.value = `ไม่สามารถแก้ไขบัญชีได้ เนื่องจากไม่พบบัญชีธนาคารดังกล่าวในระบบ`;
            }
            if (err.response.data.message.includes("Duplicate")) {
              failedTitle.value = "บัญชีซ้ำในระบบ";
              failedMessage.value =
                "ไม่สามารถแก้ไขบัญชีได้ เนื่องจากมีบัญชีซ้ำในระบบ";
            }
          }

          isEditFail.value = true;
          isWorking.value = false;
          // editBankAccountOpen.value = false;
          setTimeout(() => {
            newPassword.value = null;
          }, 1000);
        });
    };

    const saveFoceBankAccountV2 = () => {
      isWorking.value = true;
      if (!bankAccount.value.bank || !bankAccount.value.accountNumber || !accountName.value) {
        const message = 'Missing bank information!';
        alert(message);
        isWorking.value = false;
        return
      }

      if (!/^\d+$/.test(bankAccount.value.accountNumber)) {
        alert('กรุณากรอกเฉพาะตัวเลข')
        return
      }

      let body = {
        requestId: `${Date.now()}`,
        requestTs: Date.now(),
        operatorId: store.state.selectedOperator.operatorId,
        userId: userInfo.value.id,
        accountNumber: `${bankAccount.value.accountNumber}`,
        bankName: bankList.value.find((b) => b.bankCode == bankAccount.value.bank).nameTh,
        bankCode: bankAccount.value.bank,
        name: accountName.value
      };
      const forceUpdateBankAccountEndpoint = '/admin/api/v1/operator-admin/v2/user/force-update-bank-account'
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT + forceUpdateBankAccountEndpoint,
          body
        )
        .then((data) => {
          let findError = []
          if (Array.isArray(data.data.payload)) {
            data.data.payload.map((payload) => {
              if (payload.success == false) findError.push(payload.paymentName)
            })
          }
          toastConfig.value.show = true
          toastConfig.value.manual_close = true

          if (data.data.success == false) {
            isAlertBank.value = true
            alertMessage.value = data.data?.payload?.message || 'Update Failed Please Check Bank Account Again'
            toastConfig.value.success = false
            toastConfig.value.message = `Update Failed!!`
          }
          else if (findError.length > 0 && data.data.success == true) {
            toastConfig.value.warning = true
            if (Array.isArray(data.data.payload)) {
              toastConfig.value.message = [...data.data.payload.map((payload) => {
                return `[${payload.paymentName} update: ${payload.success ? `SUCCESS` : `FAILED`}]`
              }), 'กรุณาติดต่อ Support team เพื่อแก้ไข'].join(`,`)
            }
            forceEditBankAccountV2Open.value = false;
          }
          else {
            toastConfig.value.success = true
            toastConfig.value.message = `Update Success!!`
            forceEditBankAccountV2Open.value = false;
          }

          isEditFail.value = false;
          isWorking.value = false;
          refetch();
          setTimeout(() => {
            newPassword.value = null;
          }, 1000);
        })
        .catch((err) => {
          console.log(err)
          if (err.response.data.message.includes("Invalidbank")) {
            failedTitle.value = `ไม่พบบัญชีธนาคาร`;
            failedMessage.value = `ไม่สามารถแก้ไขบัญชีได้ เนื่องจากไม่พบบัญชีธนาคารดังกล่าวในระบบ`;
          }
          if (err.response.data.message.includes("Duplicate")) {
            failedTitle.value = "บัญชีซ้ำในระบบ";
            failedMessage.value =
              "ไม่สามารถแก้ไขบัญชีได้ เนื่องจากมีบัญชีซ้ำในระบบ";
          }
          isEditFail.value = true;
          isWorking.value = false;
          // editBankAccountOpen.value = false;
          setTimeout(() => {
            newPassword.value = null;
          }, 1000);
        });
    };
    const updateUserRole = () => {
      isWorking.value = true;
      const body = {
        user_id: userInfo.value.id,
        operator_id: userInfo.value.operatorId,
        role_name: affiliateUserRole,
        admin_id: store.state.user.id,
        is_active: userRoles.value.includes(affiliateUserRole) ? false : true,
      };
      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
          "/admin/api/v1/cms/customers/crete-or-update-role",
          body
        )
        .then(() => {
          isWorking.value = false;
          refetch();
        })
        .catch((err) => {
          console.log(err);
          isWorking.value = false;
          changePasswordOpen.value = false;
          setTimeout(() => {
            newPassword.value = null;
          }, 1000);
        });
    };

    const savePassword = () => {
      isWorking.value = true;

      axios
        .post(
          process.env.VUE_APP_API_ENDPOINT +
          "/admin/api/v1/operator-admin/user/reset-password",
          {
            operatorId: store.state.selectedOperator.operatorId,
            phoneNumber: userInfo.value.phoneNumber,
            newPassword: newPassword.value,
            updatedBy: store.state.user.id,
          }
        )
        .then(() => {
          isWorking.value = false;
          changePasswordOpen.value = false;
          setTimeout(() => {
            newPassword.value = null;
          }, 1000);
        })
        .catch((err) => {
          console.log(err);
          isWorking.value = false;
          changePasswordOpen.value = false;
          setTimeout(() => {
            newPassword.value = null;
          }, 1000);
        });
    };

    const onQRDeposit = async () => {
      let decode = jwt_decode(store.state.user.token);
      const formattedDepositDate = dayjs(depositDate.value);
      const api = '/admin/api/v1/operator-admin/wallet/request-deposit-qr'
      const { data: qrResponse } = await axios
        .post(
          `${process.env.VUE_APP_API_ENDPOINT}${api}`,
          {
            user_id: userInfo.value.id,
            operator_id: userInfo.value.operatorId,
            // admin_id: decode.userId,
            amount: qrDepositAmount.value.toFixed(2),
            // admin: store.state.user.username,
            ip: store.state.user.ip,
          }
        )
        .catch(function (error) {
          if (error.response && error.response.status == 400) {
            const message = error.response.data.message || "Fail";
            alert(message);
          } else {
            console.log(error.response);
          }
        });

      if (qrResponse.result && qrResponse.result?.data?.showurl) {
        window.open(qrResponse.result.data.showurl)
      }

      qrDepositAmount.value = "";
      isShowQRDeposit.value = false;

      refetch();
    }

    const onManualPaymentDepositV2 = async () => {
      if (processedApproval.value) {
        return
      }
      processedApproval.value = true
      if (manualPaymentDepositValueV2.value <= 0) {
        manualPaymentDepositErrorTextV2.value = 'minimum amount is 1'
        return;
      }
      if (!manualPaymentDepositPaymentIdV2.value.value && store.state.selectedOperator.multipleDeposit == true) {
        manualPaymentDepositErrorTextV2.value = 'please select payment'
        return;
      }
      const result = await axios
        .post(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/deposit/manual`,
          {
            userId: userInfo.value.id,
            createdBy: store.state.user.id,
            operatorId: userInfo.value.operatorId,
            amount: manualPaymentDepositValueV2.value,
            message: manualPaymentDepositNoteV2.value,
            requestedAt: depositDateV2.value,
            username: userInfo.value.username,
            ...(store.state.selectedOperator.multipleDeposit == true? {paymentId: manualPaymentDepositPaymentIdV2.value.value.toString()}:{})
          }
        )
        .catch(function (error) {
          if (error.response && (error.response.status == 400||error.response.status == 500)) {
            console.log(error.response.data.detail)
            const message = error.response.data.detail || "Fail";
            alert(message);
          } else {
            console.log(err);
          }
        });
      manualPaymentDepositValueV2.value = null
      manualPaymentDepositErrorTextV2.value = ""
      manualPaymentDepositErrorTextV2.value = null;
      if (result.data.paymentUrl) {
        window.open(result.data.paymentUrl)
        isShowManualPaymentDepositV2.value = false;
      } else if (result.data.qrCode) {
        qrCodeText.value = result.data.qrCode
        qrCodeExpiredAt.value = result.data.expiredAt ?
          typeof result.data.expiredAt == 'number' ?
            dayjs.unix(result.data.expiredAt).locale('th').format('LLL') :
            dayjs(result.data.expiredAt).locale('th').format('LLL') :
          undefined
        qrAmount.value = result.data.amount / 100
        isShowManualPaymentDepositV2.value = false;
        isShowQrManualDeposit.value = true;
      } else if (result.data.status == 'success') {
        isShowManualPaymentDepositV2.value = false;
      }
      refetch();
      processedApproval.value = false
    }

    const onManualPaymentWithdrawV2 = async () => {
      if (processedApproval.value) {
        return
      }
      processedApproval.value = true
      if (manualPaymentWithdrawValueV2.value <= 0) {
        manualPaymentWithdrawErrorTextV2.value = 'minimum amount is 1'
        return;
      }
      let decode = jwt_decode(store.state.user.token);
      await axios
        .post(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/be-payment/withdraw/manual`,
          {
            operatorId: userInfo.value.operatorId,
            createdBy: decode.userId,
            amount: Number(manualPaymentWithdrawValueV2.value) || 0,
            userId: userInfo.value.id,
            username: userInfo.value.username,
            requestId: Date.now().toString(),
            requestTs: Date.now(),
          }
        )
        .catch(function (error) {
          if (error.response && (error.response.status == 400||error.response.status == 500)) {
            const message = error.response.data.message || "Fail";
            alert(message);
          } else {
            console.log(err);
            processedApproval.value = false

          }
        });

      processedApproval.value = false
      manualPaymentWithdrawValueV2.value = null;
      manualPaymentWithdrawErrorTextV2.value = null;
      isShowManualPaymentWithdrawV2.value = false;
      manualPaymentDepositErrorTextV2.value = ""

      refetch();
    }

    const onManualPaymentDeposit = async () => {
      let decode = jwt_decode(store.state.user.token);
      const formattedDepositDate = dayjs(depositDate.value);

      const currentDepositAccount = await getAccount();
      const paymentEndpointAndPayload = {
        "MANUAL": {
          url: `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/request-deposit`,
          payload: {
            user_id: userInfo.value.id,
            operator_id: userInfo.value.operatorId,
            admin_id: decode.userId,
            amount: Number(manualPaymentDepositValue.value || 0).toString(),
            date_time: formattedDepositDate.add(7, 'hour'),
            admin: store.state.user.username,
            phone: userInfo.value.phoneNumber,
          },
          minimumDeposit: 1
        },
        "RTB": {
          url: `${process.env.VUE_APP_API_ENDPOINT}/internal/deposits/request/manual`,
          payload: {
            user_id: userInfo.value.id,
            operator_id: userInfo.value.operatorId,
            admin_id: decode.userId,
            amount: (manualPaymentDepositValue.value * 100) || 0,
            date_time: formattedDepositDate,
            admin: store.state.user.username,
            phone: userInfo.value.phoneNumber,
          },
          minimumDeposit: 1
        },
        "POWERPG": {
          url: `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/power-pg/deposit/request`,
          payload: {
            userId: userInfo.value.id,
            operatorId: userInfo.value.operatorId,
            amount: manualPaymentDepositValue.value || 0
          },
          minimumDeposit: 100
        },
        "ZPAY": {
          url: `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/zpay/deposit/request`,
          payload: {
            userId: userInfo.value.id,
            operatorId: userInfo.value.operatorId,
            amount: manualPaymentDepositValue.value || 0
          },
          minimumDeposit: 100
        },
      }
      const paymentDeposit = paymentEndpointAndPayload[currentDepositAccount.paymentAccountType]
      if (manualPaymentDepositValue.value < paymentDeposit.minimumDeposit) {
        manualPaymentDepositErrorText.value = `minimum amount is ${paymentDeposit.minimumDeposit}`
        return
      }
      const result = await axios
        .post(
          paymentDeposit.url,
          paymentDeposit.payload
        )
        .catch(function (error) {
          if (error.response && error.response.status == 400) {
            const message = error.response.data.status || "Fail";
            alert(message);
          } else {
            console.log(err);
          }
        });

      if (currentDepositAccount.paymentAccountType === "POWERPG") {
        window.open(result.data.paymentUrl)
      }

      if (currentDepositAccount.paymentAccountType === "ZPAY") {
        window.open(result.data.redirect_url)
      }

      manualPaymentDepositValue.value = "";
      manualPaymentDepositErrorText.value = ""
      isShowManualPaymentDeposit.value = false;

      refetch();
    };

    const getAccount = async () => {
      let payload = {
        operatorId: store.state.selectedOperator.operatorId,
      };
      const { result } = await axios
        .post(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator/payment/account/list`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        )
        .then(({ data }) => data);
      // [ZPAY: {isActive: true, useWithdraw: false}, RTB: {isActive: true, useWithdraw: true}]
      // const activePayment = result.filter((pa)=> pa.isActive && pa.paymentAccountType!='ZPAY')
      const deposit = result.find((pa) => pa.isActive && pa.useDeposit)
      return deposit
    };

    const onManualPaymentWithdraw = async () => {
      let decode = jwt_decode(store.state.user.token);
      await axios
        .post(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/operator-admin/wallet/withdraw`,
          {
            operatorId: userInfo.value.operatorId,
            adminId: decode.userId,
            amount: `${manualPaymentDepositValue.value || 0}`,
            userPhone: userInfo.value.username,
            requestId: Date.now().toString(),
            requestTs: Date.now(),
          }
        )
        .catch(function (error) {
          if (error.response && error.response.status == 400) {
            const message = error.response.data.status || "Fail";
            alert(message);
          } else {
            console.log(err);
          }
        });

      manualPaymentDepositValue.value = "";
      isShowManualPaymentWithdraw.value = false;

      refetch();
    };

    const onSuspendUser = async (suspendUserId) => {
      try {
        const route = suspendData.value.isActive ? 'suspend' : 'activate'
        await axios.post(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/user-status/${route}`,
          {
            operatorId: store.state.selectedOperator.operatorId,
            userId: suspendUserId,
            adminId: store.state.user.id,
            notes: reason.value || ""
          }
        );
        isSuspend.value = false;
        refetch();
      } catch (e) {
        alert('Permissions access denied')
        isSuspend.value = false
      }
    };

    const onActiveUser = async (activateUserId) => {
      await axios.post(
        `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/user-status/activate`,
        {
          operatorId: store.state.selectedOperator.operatorId,
          userId: activateUserId,
          adminId: store.state.user.id,
        }
      );

      // isActivateUser.value = false;
      refetch();
    };

    const onCreateTicket = async ({ formData, form_name }) => {
      formLoading.value = true
      if (!formData.has('user_id')) formData.set('user_id', '')
      const validate_result = check_require_field(form_name, formData)
      if (validate_result.validated) {
        toastConfig.value.manual_close = false
        const ticket = await axios.post(
          `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/ticket/create`,
          formData
        )
        console.log('[E] ~ onCreateTicket ~ ticket:', ticket)

        toastConfig.value.show = true
        if (ticket.data) {
          toastConfig.value.success = ticket.data.is_success
          if (ticket.data.is_success) {
            toastConfig.value.message = 'Ticket Created'
            showCreateTicketModal.value = !showCreateTicketModal.value
          } else toastConfig.value.message = 'Create Ticket Failed'
        } else {
          toastConfig.value.success = false
          toastConfig.value.message = 'Create Ticket Failed'
        }
      } else {
        toastConfig.value.show = true
        toastConfig.value.success = false
        toastConfig.value.message = `Missing fields ${validate_result.missing_field}`
        toastConfig.value.manual_close = true
      }
      formLoading.value = false
    }

    return {
      file,
      preview,
      imageUrl,
      uploadPic,
      onFileSelected,
      refetch,
      store,
      userInfo,
      transactions,
      isLoaded,
      bankList,
      dayjs,
      tabs,
      route,
      pages,
      changePasswordOpen,
      editBankAccountOpen,
      editBankAccountV2Open,
      forceEditBankAccountV2Open,
      forceEditBankAccountOpen,
      toggleChangePasswordModal,
      toggleEditBankAccountModal,
      toggleEditBankAccountV2Modal,
      toggleForceEditBankAccountV2Modal,
      toggleForceEditBankAccountModal,
      saveFoceBankAccountV2,
      saveForceBankAccount,
      isWorking,
      newPassword,
      accountName,
      bankAccount,
      savePassword,
      saveBankAccount,
      isEditFail,
      failedTitle,
      failedMessage,
      onManualPaymentDeposit,
      onManualPaymentWithdraw,
      isShowManualPaymentDeposit,
      isShowManualPaymentWithdraw,
      manualPaymentDepositValue,
      manualPaymentDepositErrorText,
      depositDate,
      userRoles,
      updateUserRole,
      isAffiliateUser,
      changePage,
      selected_tab,
      isManualTopupPoint,
      updateSuspendData,
      suspendData,
      isSuspend,
      onSuspendUser,
      onActiveUser,
      isUsernameUpdate,
      isUpdateRedeemLimit,
      onCheckFuture,
      camalize,
      onQRDeposit,
      isShowQRDeposit,
      qrDepositAmount,
      reason,
      userActivityLogs,
      showCreateTicketModal,
      onCreateTicket,
      toastConfig,
      formLoading,
      isPlayer,
      depositDateV2,
      manualPaymentDepositValueV2,
      manualPaymentDepositNoteV2,
      manualPaymentWithdrawValueV2,
      manualPaymentWithdrawNoteV2,
      manualPaymentDepositErrorTextV2,
      manualPaymentWithdrawErrorTextV2,
      isShowManualPaymentDepositV2,
      isShowManualPaymentWithdrawV2,
      onManualPaymentDepositV2,
      onManualPaymentWithdrawV2,
      saveBankAccountV2,
      qrCodeText,
      isShowQrManualDeposit,
      qrAmount,
      qrCodeExpiredAt,
      isAlertBank,
      alertMessage,
      processedApproval,
      manualPaymentDepositPaymentIdV2
    };
  },
};
</script>
